











  import { Component, Vue } from 'nuxt-property-decorator'
  import { namespace } from 'vuex-class'

  const layout = namespace('layout')
  @Component({
    components: {
      OneButtonToggle: () => import('~/components/molecules/buttons/OneButtonToggle.vue'),
    },
  })
  export default class OneTaxSwitcherComponent extends Vue {
    @layout.Mutation('SET_HIDDEN_PRICES') setHiddenPrices: any
    @layout.State(state => state.hiddenPrices) isHidePrices!: boolean
  }
